import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, Input, ViewChild } from '@angular/core';
import { APP_CONFIG } from '../../../app.config';
import { AppConfig } from '../../../models/config/app-config';

/** @dynamic */
@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss']
})
export class StatusBarComponent {
  isNavigationFixed: boolean;
  thresholdY?: number;
  replacementHeight: string;

  @Input()
  validities: any;

  @Input()
  myform: any;

  @ViewChild('wrapper', { static: true }) element: ElementRef;
  @ViewChild('replacement', { static: true }) replacementElement: ElementRef;

  constructor(@Inject(APP_CONFIG) public appConfig: AppConfig,
              @Inject(DOCUMENT) private document: Document) {
  }

  isValid(formName: string): boolean {
    return !(this.validities && this.validities[formName] && this.validities[formName].valid === false);
  }

  // TODO eleganter loesen?
  isVisible(formName: string) {
    if ('kostenuebernahme' === formName) {
      return this.isKostenuebernahmeVisible();
    }

    if ('referenz' === formName) {
      return this.isReferenzVisible();
    }


    return true;
  }

  private isReferenzVisible(): boolean {
    if (this.appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT') {
      return this.myform && this.myform.angabenZurPerson && this.myform.angabenZurPerson.isRechtAufFreizuegigkeit !== true;
    }

    return true;
  }

  private isKostenuebernahmeVisible(): boolean {
    if (this.appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT') {
      return this.myform && this.myform.kostenuebernahme;
    }

    return false;
  }


  scroll(scrollTarget: string) {
    const element = document.getElementById(scrollTarget);
    const yOffset = -350;
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.thresholdY === undefined) {
      const el = this.element.nativeElement;
      this.thresholdY = el.offsetTop || this.replacementElement.nativeElement.offsetTop;
      this.replacementHeight = el.offsetHeight + 'px';
    }
    const scrollY = this.document.documentElement.scrollTop;
    this.isNavigationFixed = (scrollY > this.thresholdY);
  }

  @HostListener('window:resize', [])
  onWindowResize() {
    this.thresholdY = undefined;
    this.replacementHeight = '';
  }
}
